import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5545d8c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-semibold" }, "Receive NFTs", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Donation Amount ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Series ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7V4.9875C5.5 4.84583 5.45217 4.72917 5.3565 4.6375C5.2605 4.54583 5.14167 4.5 5 4.5C4.85833 4.5 4.73967 4.54783 4.644 4.6435C4.548 4.7395 4.5 4.85833 4.5 5V7.0125C4.5 7.15417 4.548 7.27083 4.644 7.3625C4.73967 7.45417 4.85833 7.5 5 7.5ZM5 3.5C5.14167 3.5 5.2605 3.452 5.3565 3.356C5.45217 3.26033 5.5 3.14167 5.5 3C5.5 2.85833 5.45217 2.7395 5.3565 2.6435C5.2605 2.54783 5.14167 2.5 5 2.5C4.85833 2.5 4.73967 2.54783 4.644 2.6435C4.548 2.7395 4.5 2.85833 4.5 3C4.5 3.14167 4.548 3.26033 4.644 3.356C4.73967 3.452 4.85833 3.5 5 3.5ZM5 10C4.30833 10 3.65833 9.86867 3.05 9.606C2.44167 9.34367 1.9125 8.9875 1.4625 8.5375C1.0125 8.0875 0.656333 7.55833 0.394 6.95C0.131333 6.34167 0 5.69167 0 5C0 4.30833 0.131333 3.65833 0.394 3.05C0.656333 2.44167 1.0125 1.9125 1.4625 1.4625C1.9125 1.0125 2.44167 0.656167 3.05 0.3935C3.65833 0.131167 4.30833 0 5 0C5.69167 0 6.34167 0.131167 6.95 0.3935C7.55833 0.656167 8.0875 1.0125 8.5375 1.4625C8.9875 1.9125 9.34367 2.44167 9.606 3.05C9.86867 3.65833 10 4.30833 10 5C10 5.69167 9.86867 6.34167 9.606 6.95C9.34367 7.55833 8.9875 8.0875 8.5375 8.5375C8.0875 8.9875 7.55833 9.34367 6.95 9.606C6.34167 9.86867 5.69167 10 5 10Z",
      fill: "#6D7380"
    })
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Carbon NFT ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Life NFT ")
const _hoisted_7 = { class: "font-medium" }
const _hoisted_8 = { class: "text-gray-info text-14" }
const _hoisted_9 = { class: "text-14 text-center" }
const _hoisted_10 = { class: "text-center text-14" }
const _hoisted_11 = { class: "text-center text-14" }
const _hoisted_12 = ["onClick", "data-testid"]
const _hoisted_13 = {
  key: 1,
  class: "text-gray-description text-14 text-center w-28"
}
const _hoisted_14 = {
  key: 1,
  class: "text-center grid justify-center mt-16"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-description text-xl" }, "Not Found", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-2xl mb-6" }, " Do you have an account (Wallet) for receiving NFTs? ", -1))
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Yes ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" No ")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-2xl mb-6" }, " You will need an account (wallet) for receiving NFTs. ", -1))
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Create an account ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Go back ")

import type { ClaimingReceiveResponse } from '@/types/Claiming';
import { computed, ref, watch } from 'vue';
import ListGrouped from '@/components/ListGrouped.vue';
import { roundNumber } from '@/utils/numbers';
import { useUserStore } from '@/store/user';
import { useRouter } from 'vue-router';
import Popper from 'vue3-popper';
import { displayGroupTitle } from '@/utils/dates';

interface Props {
  transactions: ClaimingReceiveResponse | null;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    transactions: { default: null }
  },
  setup(__props: any) {

const props = __props as { transactions: ClaimingReceiveResponse | null }



const receive = ref<boolean>(false);
const accountToReceive = ref<boolean>(false);
const idReceiveNft = ref();
const userStore = useUserStore();
const authenticated = computed(() => !!userStore.me);
const router = useRouter();
const isLoading = ref<boolean>(true);
watch(
  () => props.transactions,
  () => {
    setTimeout(() => {
      isLoading.value = false;
    }, 100);
  }
);

const displayDateTimeUTC = (date: string) => {
  const d = new Date(date);
  const timezone = d.getTimezoneOffset() / -60;
  const getDate = d.getDate();
  const getMonth = d.getMonth();
  const getHours = d.getHours();
  const getMinutes = d.getMinutes();
  const getSeconds = d.getSeconds();
  return `${getDate < 10 ? '0' + getDate : getDate}-${
    getMonth + 1 < 10 ? `0${getMonth + 1}` : getMonth + 1
  }-${d.getFullYear()}, ${getHours < 10 ? '0' + getHours : getHours}:${
    getMinutes < 10 ? '0' + getMinutes : getMinutes
  }:${getSeconds < 10 ? '0' + getSeconds : getSeconds} ${
    getHours >= 12 ? 'PM' : 'AM'
  } ${timezone > 0 ? '+' + timezone : timezone} UTC`;
};

const groupBy = (item: Record<string, string>) => {
  return displayGroupTitle(item.createdAt);
};

const sorter = (a: string | number, b: string | number) => {
  return new Date(b).getTime() - new Date(a).getTime();
};

const getRound = (val: string | number) => {
  return roundNumber(parseFloat(val.attributes.series));
};

const getNumNft = (val: string | number) => {
  return roundNumber(parseFloat(val.attributes.amount));
};

const getClaimedNft = (val: string | number) => {
  return val.attributes.claimedAt;
};

const receiveNft = (item: string | number) => {
  localStorage.setItem('receive_email', item.attributes.email);
  localStorage.setItem('receive_id', item.id);
  localStorage.setItem('receive_donate_id', item.attributes.donationId);
  localStorage.setItem('receive_channel', item.attributes.channel);
  idReceiveNft.value =
    userStore.isGeneratedUser && authenticated.value
      ? item.attributes.donationId
      : item.id;
  if (authenticated.value) {
    router.push(`/landing/receive/${idReceiveNft.value}/login`);
  } else {
    receive.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_BaseTableColumn = _resolveComponent("BaseTableColumn")!
  const _component_BaseTable = _resolveComponent("BaseTable")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseModal = _resolveComponent("BaseModal")!
  const _component_BaseBox = _resolveComponent("BaseBox")!

  return (_openBlock(), _createBlock(_component_BaseBox, { class: "card my-6" }, {
    default: _withCtx(() => [
      _hoisted_1,
      (isLoading.value || __props.transactions?.entities)
        ? (_openBlock(), _createBlock(ListGrouped, {
            key: 0,
            items: __props.transactions?.entities,
            "group-by": groupBy,
            sorter: sorter
          }, {
            header: _withCtx(({ key }) => [
              _createTextVNode(_toDisplayString(_unref(displayGroupTitle)(key)), 1)
            ]),
            default: _withCtx(({ items }) => [
              _createVNode(_component_BaseTable, {
                source: items,
                "key-by": "id",
                "is-loading": isLoading.value
              }, {
                attributes: _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(data.grandTotal) + " " + _toDisplayString(data.currency), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(displayDateTimeUTC(data.createdAt)), 1)
                ]),
                round: _withCtx(({ item }: { item: any }) => [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(getRound(item)), 1)
                ]),
                carbon: _withCtx(({ item }: { item: any }) => [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(getNumNft(item)), 1)
                ]),
                life: _withCtx(({ item }: { item: any }) => [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(getNumNft(item)), 1)
                ]),
                receive: _withCtx(({ item }: { item: any }) => [
                  (!getClaimedNft(item))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "text-blue-link text-14 text-center cursor-pointer w-28",
                        onClick: ($event: any) => (receiveNft(item)),
                        "data-testid": `receive-nft=${item.id}`
                      }, " Receive ", 8, _hoisted_12))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, " Received "))
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_BaseTableColumn, {
                    id: "attributes",
                    class: "text-14"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BaseTableColumn, {
                    id: "round",
                    class: "text-14",
                    style: {"text-align":"center"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _createVNode(_unref(Popper), {
                        arrow: "",
                        content: " “Series” is the term used to denote a specific period of\n                  donation. Each series will cover a span of one year. For this\n                  reason, it should be noted that each NFT icon generated from\n                  different series will vary accordingly.",
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BaseTableColumn, {
                    style: {"text-align":"center !important"},
                    id: "carbon",
                    class: "text-14"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BaseTableColumn, {
                    style: {"text-align":"center !important"},
                    id: "life",
                    class: "text-14"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BaseTableColumn, { id: "receive" })
                ]),
                _: 2
              }, 1032, ["source", "is-loading"])
            ]),
            _: 1
          }, 8, ["items"]))
        : (!__props.transactions.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("img", {
                src: require('@/assets/svg/empty-receive-nft.svg'),
                alt: "empty",
                class: "mb-6 text-xl"
              }, null, 8, _hoisted_15),
              _hoisted_16
            ]))
          : _createCommentVNode("", true),
      _createVNode(_component_BaseModal, {
        modelValue: receive.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((receive).value = $event)),
        "content-style": { 'max-width': '440px' }
      }, {
        default: _withCtx(() => [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_router_link, {
              to: `/landing/auth/login/receive/${idReceiveNft.value}`,
              "data-testid": `receive-have-account`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_BaseButton, {
                  "color-scheme": "primary",
                  height: "44px",
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_BaseButton, {
              "color-scheme": "border",
              height: "44px",
              class: "w-full",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (accountToReceive.value = true))
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_BaseModal, {
        modelValue: accountToReceive.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((accountToReceive).value = $event)),
        "content-style": { 'max-width': '440px' }
      }, {
        default: _withCtx(() => [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_router_link, {
              to: `/landing/auth/signup/receive/${idReceiveNft.value}`,
              "data-testid": `receive-create-account`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_BaseButton, {
                  "color-scheme": "primary",
                  height: "44px",
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_BaseButton, {
              "color-scheme": "white",
              height: "44px",
              class: "w-full",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).back()))
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})